import React from 'react';
import Box from "@mui/material/Box";
import camHouse from "../../images/camHouse.jpg";
import Typography from "@mui/material/Typography";
import {Card, CardContent} from "@mui/material";
import CameraOutdoorIcon from '@mui/icons-material/CameraOutdoor';
import SensorsIcon from '@mui/icons-material/Sensors';
import DoorbellIcon from '@mui/icons-material/Doorbell';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import DialpadIcon from '@mui/icons-material/Dialpad';
import RememberMeIcon from '@mui/icons-material/RememberMe';
import Partenaires from "../Partenaires";
import ContactUs from "../ContactUs";
import AnimatedBackgroundBox from "../AnimationBackgroundBox";
import Grid2 from "@mui/material/Unstable_Grid2";

const Securite = () => {
    return (
                        // <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        //     Protégez votre maison ou entreprise avec nos systèmes de sécurité avancés :
                        //     alarmes, vidéosurveillance.
                        // </Typography>

    <React.Fragment>
        <AnimatedBackgroundBox backgroundImage={camHouse} position={'center'} size={'200%'}>

            <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#ebefef', fontFamily: 'unset',
                textShadow: `
                            0px 0px 8px rgba(0, 0, 0, 0.3),   
                            0px 0px 16px rgba(0, 0, 0, 0.3),  
                            0px 0px 24px rgba(0, 0, 0, 0.3)   
                        `,
                fontSize: {
                    xs: '2.5rem', // Taille plus petite sur les téléphones
                    sm: '2.5rem', // Taille moyenne sur les tablettes
                    md: '5rem', // Taille normale sur les grands écrans
                },
            }}>
                Sécurité
            </Typography>
        </AnimatedBackgroundBox>

        <Box sx={{
            padding: { xs: '20px ', md: '70px 0' },
            //backgroundColor: 'rgba(233,240,246,0.98)'
            backgroundColor: '#f0f4fa'
        }}>
            <Box sx={{ maxWidth: 'lg', margin: 'auto', textAlign: 'center' }}>
                <Typography
                    variant="h4"
                    sx={{
                        fontFamily: 'unset',
                        color: '#2c2d2e',
                        paddingBottom: '50px',
                        textAlign: 'center', // Centrage du texte
                        //fontStyle: 'italic'
                        fontSize: { xs: '1.5rem', md: '2rem' }

                    }}
                >
                    Assurez la protection de vos proches et de vos biens avec nos solutions de sécurité innovantes, pensées pour votre sérénité.                    {/*Que ce soit pour l'installation, la rénovation ou la maintenance de vos systèmes électriques, nous garantissons sécurité, performance et conformité, tout en optimisant votre consommation énergétique.*/}
                </Typography>

                <Grid2 container spacing={4} justifyContent="center"> {/* Centrage des cartes */}
                    {/** Tableau de données pour les cartes */}
                    {[
                        {
                            icon: <CameraOutdoorIcon sx={{ fontSize: 75, color: '#000000', mb: 2 }} />,
                            title: "CAMÉRA DE SURVEILLANCE",
                            description: "Gardez un œil sur votre domicile ou vos locaux 24h/24 grâce à des caméras haute résolution. " +
                                "Notre équipe installe et configure les caméras pour une surveillance en temps réel accessible depuis votre smartphone ou votre ordinateur.",
                        },
                        {
                            icon: <SensorsIcon sx={{ fontSize: 75, color: '#32cc0f', mb: 2 }} />,
                            title: "DÉTECTEURS DE CHUTE",
                            description: "Offrez une protection supplémentaire aux personnes âgées vivant seules. " +
                                "Les détecteurs de chute détectent automatiquement tout incident et déclenchent une alerte pour un contact rapide avec les secours.",
                        },
                        {
                            icon: <DoorbellIcon sx={{ fontSize: 75, color: '#000000', mb: 2 }} />,
                            title: "ALARME ANTI-INTRUSION",
                            description: "Protégez votre maison des intrusions avec une alarme intelligente qui détecte toute tentative d'effraction et vous alerte immédiatement. " +
                                "Recevez des alertes directement sur votre smartphone.",
                        },
                        {
                            icon: <DialpadIcon sx={{ fontSize: 75, color: '#3c89ec', mb: 2 }} />,
                            title: "CONTRÔLE D'ACCÈS",
                            description: "Limitez l’accès aux espaces privés avec un contrôle d’accès par carte, code ou empreinte digitale. " +
                                "Parfait pour les bureaux et les résidences sécurisées.",
                        },
                        {
                            icon: <LocalFireDepartmentIcon sx={{ fontSize: 75, color: '#ec3c3c', mb: 2 }} />,
                            title: "DÉTECTEURS DE FUMÉE ET DE GAZ",
                            description: "Installez des détecteurs de fumée et de gaz pour protéger votre habitation des incendies et des fuites de gaz. " +
                                "Nos systèmes sont certifiés et respectent les normes de sécurité en vigueur.",
                        },
                        {
                            icon: <RememberMeIcon sx={{ fontSize: 75, color: '#3c89ec', mb: 2 }} />,
                            title: "VIDÉO-INTERPHONIE",
                            description: "Vérifiez l’identité des visiteurs avant d’ouvrir votre porte. " +
                                "Le système vidéo vous permet de voir, entendre, et parler à distance à toute personne à l’entrée.",
                        },
                    ].map((card, index) => (
                        <Grid2 xs={12} sm={6} md={6} key={index}>
                            <Card
                                sx={{
                                    minWidth: 300,
                                    minHeight: 300,
                                    maxHeight: 350,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: 8,
                                    //boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1), 0px 10px 20px rgba(0, 0, 0, 0.2)' // Ombre plus accentuée
                                    boxShadow: '0px 5px 5px rgb(170, 187, 250, 0.5), 0px 5px 10px rgb(170, 187, 250, 0.4) '

                                }}
                            >
                                <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                    {card.icon}
                                    <Typography variant="h5" sx={{ mb: 1.5, fontFamily: 'unset' }}>
                                        {card.title}
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontFamily: 'unset' }}>
                                        {card.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid2>
                    ))}
                </Grid2>

            </Box>
        </Box>

        <Box>
            <Partenaires></Partenaires>
        </Box>
        <Box>
            <ContactUs></ContactUs>
        </Box>
    </React.Fragment>
    );
};

export default Securite;